import React from 'react';
import { useApp } from '../../context/AppContext';
import './Dashboard.css';

const Dashboard = () => {
  const { cases, hearings, judgments, user } = useApp();

  const today = new Date().toISOString().split('T')[0];
  const todayHearings = hearings.filter(h => h.hearingDate === today);
  const pendingCases = cases.filter(c => c.status !== 'Disposed');
  const disposedCases = cases.filter(c => c.status === 'Disposed');
  const recentJudgments = judgments.slice(0, 5);

  const stats = [
    { label: 'Total Cases', value: cases.length, icon: '📁', color: '#667eea' },
    { label: 'Pending Cases', value: pendingCases.length, icon: '⏳', color: '#f093fb' },
    { label: "Today's Hearings", value: todayHearings.length, icon: '📅', color: '#4facfe' },
    { label: 'Disposed Cases', value: disposedCases.length, icon: '✅', color: '#43e97b' },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Welcome back, {user?.username}! Here's an overview of your court system.</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Today's Hearings</h2>
          {todayHearings.length > 0 ? (
            <div className="hearing-list">
              {todayHearings.map((hearing) => (
                <div key={hearing.id} className="hearing-item">
                  <div>
                    <strong>{hearing.caseNumber}</strong>
                    <p>{hearing.courtName} - {hearing.benchName}</p>
                  </div>
                  <div className="hearing-time">{hearing.hearingTime}</div>
                </div>
              ))}
            </div>
          ) : (
            <p className="empty-state">No hearings scheduled for today</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>Recent Judgments</h2>
          {recentJudgments.length > 0 ? (
            <div className="judgment-list">
              {recentJudgments.map((judgment) => (
                <div key={judgment.id} className="judgment-item">
                  <div>
                    <strong>{judgment.caseNumber}</strong>
                    <p>{new Date(judgment.judgmentDate).toLocaleDateString()}</p>
                  </div>
                  <span className="judgment-status">{judgment.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="empty-state">No recent judgments</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

